// Import Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

// import current language from global
import Button from '~/common/components/CommonButton';

import { PATH_NUMBERS } from '~/common/utils/consts.js';

// Import Stylesheet
import styles from './CantLockNumberToSessionModalContent.css';

@inject('modalStore')
@observer
class CantLockNumberToSessionModalContent extends Component {
    closeModalAndRedirect() {
        this.props.modalStore.setModalOptions({ isModalOpen: false });
    }

    render() {
        return (
            <div>
                <h1 className={styles.header}>Oh no!</h1>
                <p className={styles.content}>Looks like the number you chose is no longer available. Please choose a new one below.</p>
                <Button modifier={styles.btn} onClick={e => this.closeModalAndRedirect(e)}>
                    <Link to={PATH_NUMBERS}>
                        Choose another number
                    </Link>
                </Button>
            </div>
        );
    }
}

export default CantLockNumberToSessionModalContent;
